/*
  NBV2 Audience (sections/nbv2-audience.liquid)

  The track in assets/section-nbv2-audience.css is a native scroll-snap
  container, so swipe, trackpad and keyboard already work without this file.
  All this script adds is the arrow pair: one card per click, and a disabled
  state at each end so the buttons never lie about what is left to scroll.
*/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-nbv2-audience]';

  function prefersReducedMotion() {
    return (
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function init(root) {
    if (root.nbv2AudienceInit === true) {
      return;
    }

    var track = root.querySelector('[data-nbv2-aud-track]');
    var nav = root.querySelector('[data-nbv2-aud-nav]');
    var prev = root.querySelector('[data-nbv2-aud-prev]');
    var next = root.querySelector('[data-nbv2-aud-next]');

    if (!track || !nav || !prev || !next) {
      return;
    }

    root.nbv2AudienceInit = true;

    var ticking = false;

    /*
      One click moves by one card. Measuring the rendered card instead of
      recomputing the CSS formula keeps the two in step no matter which
      breakpoint's per-view value is live.
    */
    function step() {
      var card = track.querySelector('.nbv2-audience__card');
      if (!card) {
        return track.clientWidth;
      }
      var gap = parseFloat(window.getComputedStyle(track).columnGap);
      if (isNaN(gap)) {
        gap = 0;
      }
      return card.offsetWidth + gap;
    }

    function scrollable() {
      /* 1px of slack: fractional layout widths make exact compares unreliable. */
      return track.scrollWidth - track.clientWidth > 1;
    }

    function update() {
      ticking = false;

      var overflows = scrollable();
      nav.hidden = !overflows;

      if (!overflows) {
        return;
      }

      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }

    function requestUpdate() {
      if (ticking) {
        return;
      }
      ticking = true;

      /* Frames only arrive while the tab is visible; fall back to a timer. */
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(update);
      } else {
        window.setTimeout(update, 16);
      }
    }

    function scrollByCard(direction) {
      var distance = step() * direction;
      if (track.scrollBy) {
        track.scrollBy({
          left: distance,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      } else {
        track.scrollLeft += distance;
      }
    }

    function onPrev() {
      scrollByCard(-1);
    }

    function onNext() {
      scrollByCard(1);
    }

    prev.addEventListener('click', onPrev);
    next.addEventListener('click', onNext);
    track.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    var observer = null;
    if (typeof ResizeObserver === 'function') {
      observer = new ResizeObserver(requestUpdate);
      observer.observe(track);
    }

    update();

    root.nbv2AudienceDestroy = function () {
      prev.removeEventListener('click', onPrev);
      next.removeEventListener('click', onNext);
      track.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      if (observer) {
        observer.disconnect();
      }
      root.nbv2AudienceInit = false;
      root.nbv2AudienceDestroy = null;
    };
  }

  function initAll(scope) {
    var container = scope || document;
    var roots = Array.prototype.slice.call(container.querySelectorAll(ROOT_SELECTOR));

    if (container.nodeType === 1 && container.matches && container.matches(ROOT_SELECTOR)) {
      roots.push(container);
    }

    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = Array.prototype.slice.call(event.target.querySelectorAll(ROOT_SELECTOR));
    roots.forEach(function (root) {
      if (typeof root.nbv2AudienceDestroy === 'function') {
        root.nbv2AudienceDestroy();
      }
    });
  });
})();
